// extracted by mini-css-extract-plugin
export default {"about":"styles_about__-Ujcs","header":"styles_header__SkGDJ","text":"styles_text__GECYs"};